(async () => {
  await new CompareHelperV2(
    GLOBAL_COMPARE_OBJECT.product.id,
    GLOBAL_COMPARE_OBJECT.collection.id,
    GLOBAL_COMPARE_OBJECT.collection.title,
    GLOBAL_COMPARE_OBJECT.collection.handle
  ).init();

  const compareWrapper = document.querySelector('.pdp__compare__wrapper');
  const crossWrapper = document.querySelector('.pdp__cross__wrapper');
  if (crossWrapper) {
    const splideConfig = compareWrapper
      ? {
          type: 'slide',
          rewind: true,
          rewindByDrag: true,
          rewindSpeed: 1500,
          perPage: 2,
          perMove: 1,
          pagination: false,
          classes: {
            arrow: 'pdp__cross__slider__arrow',
            prev: 'splide__arrow--prev pdp__cross__slider__arrow--prev',
            next: 'splide__arrow--next pdp__cross__slider__arrow--next',
          },
          breakpoints: {
            500: {
              perPage: 1,
            },
            1000: {
              perPage: 2,
            },
            1536: {
              perPage: 1,
            },
          },
        }
      : {
          type: 'slide',
          rewind: true,
          rewindByDrag: true,
          rewindSpeed: 1500,
          perPage: 6,
          perMove: 1,
          pagination: false,
          classes: {
            arrow: 'pdp__cross__slider__arrow',
            prev: 'splide__arrow--prev pdp__cross__slider__arrow--prev',
            next: 'splide__arrow--next pdp__cross__slider__arrow--next',
          },
          breakpoints: {
            500: {
              perPage: 1,
            },
            1000: {
              perPage: 2,
            },
            1200: {
              perPage: 4,
            },
            1536: {
              perPage: 5,
            },
          },
        };
    const crossSellSplideElement = document.querySelector('.js-cross-sell-splide');
    const crossSellSplide = new Splide(crossSellSplideElement, splideConfig).mount();
    if (crossSellSplideElement.querySelector('.splide__list').children.length === 1) {
      crossSellSplide.destroy();
    }
  }
})();
